const boxShadow = {
    name: "box-shadow",
    path: "box-shadow",
    title: "box-shadow",
    description: "Utilities for controlling the box shadow of an element.",
    value: {
        "box-shadow": {
            "shadow-2xs": "var(--shadow-2xs)",   // 0 1px rgb(0 0 0 / 0.05)
            "shadow-xs": "var(--shadow-xs)",     // 0 1px 2px 0 rgb(0 0 0 / 0.05)
            "shadow-sm": "var(--shadow-sm)",     // 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)
            "shadow-md": "var(--shadow-md)",     // 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)
            "shadow-lg": "var(--shadow-lg)",     // 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)
            "shadow-xl": "var(--shadow-xl)",     // 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)
            "shadow-2xl": "var(--shadow-2xl)",   // 0 25px 50px -12px rgb(0 0 0 / 0.25)
            "shadow-none": "0 0 #0000",
            "shadow-inset-2xs": "var(--shadow-inset-2xs)",
            "shadow-inset-xs": "var(--shadow-inset-xs)",
            "shadow-inset-sm": "var(--shadow-inset-sm)",
            "shadow-inset-md": "var(--shadow-inset-md)",    
            "shadow-inset-lg": "var(--shadow-inset-lg)",
            "shadow-inset-xl": "var(--shadow-inset-xl)",
            "shadow-inset-2xl": "var(--shadow-inset-2xl)",
        },
        "":{
            "shadow-color-<color>": "--uni-shadow-color: <color>",
            "shadow-inset-color-<color>": "--uni-inset-shadow-color: <color>",
            "ring": "--uni-ring-shadow: 0 0 0 1px",
            "ring-<number>":"--uni-ring-shadow: 0 0 0 <number>px",
            "ring-color-<color>": "--uni-ring-color: <color>",
            "ring-inset": "--uni-inset-ring-shadow: inset 0 0 0 1px",
            "ring-inset-<number>": "--uni-inset-ring-shadow: inset 0 0 0 <number>px",
            "ring-inset-color-<color>": "--uni-inset-ring-color: <color>",
        }
    },
    exampleData: [
        {
            "title": "shadow-sm, shadow-lg",
            "description": " to apply different sized outer box shadows to an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-2xs bg-color-white",
                        "className": "",
                        "text": "shadow-2xs",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-xs bg-color-white",
                        "className": "",
                        "text": "shadow-xs",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-sm bg-color-white",
                        "className": "",
                        "text": "shadow-sm",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-md bg-color-white",
                        "className": "",
                        "text": "shadow-md",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-lg bg-color-white",
                        "className": "",
                        "text": "shadow-lg",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-xl bg-color-white",
                        "className": "",
                        "text": "shadow-xl",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-2xl bg-color-white",
                        "className": "",
                        "text": "shadow-2xl",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-[0_35px_35px_rgba(0,0,0,0.25)] bg-color-white",
                        "className": "",
                        "text": "shadow-[0_35px_35px_rgba(0,0,0,0.25)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<div class="shadow-xs" />
<div class="shadow-lg" />
<div class="shadow-xl" />
<div class="shadow-[0_35px_35px_rgba(0,0,0,0.25)]" />`
            }
        },
        {
            "title": "shadow-color-purple-500/80, shadow-color-[rgb(244_67_54_/75)]",
            "description": "to change the color of a drop shadow:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-2xl shadow-color-gray-500/80 bg-color-white",
                        "className": "",
                        "text": "shadow-color-gray-500/80",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-2xl shadow-color-purple-500/80 bg-color-purple-500",
                        "className": "",
                        "text": "shadow-color-purple-500/80",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-2xl shadow-color-[rgb(244_67_54_/75)] bg-color-[#f44336]",
                        "className": "",
                        "text": "shadow-color-[rgb(244_67_54_/75)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<div class="shadow-2xl shadow-color-gray-500/80" />
<div class="shadow-2xl shadow-color-purple-500/80" />
<div class="shadow-2xl shadow-color-[rgb(244_67_54_/75)]" />`
            }
        },
        {
            "title": "shadow-inset-sm, shadow-inset-lg",
            "description": " to apply an inset box shadow to an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-2xs bg-color-white",
                        "className": "",
                        "text": "shadow-inset-2xs",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-xs bg-color-white",
                        "className": "",
                        "text": "shadow-inset-xs",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-sm bg-color-white",
                        "className": "",
                        "text": "shadow-inset-sm",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-md bg-color-white",
                        "className": "",
                        "text": "shadow-inset-md",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-lg bg-color-white",
                        "className": "",
                        "text": "shadow-inset-lg",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-xl bg-color-white",
                        "className": "",
                        "text": "shadow-inset-xl",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-2xl bg-color-white",
                        "className": "",
                        "text": "shadow-inset-2xl",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-[inset_0_35px_35px_rgba(0,0,0,0.25)] bg-color-white",
                        "className": "",
                        "text": "shadow-[inset_0_35px_35px_rgba(0,0,0,0.25)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<div class="shadow-inset-xs" />
<div class="shadow-inset-lg" />
<div class="shadow-inset-xl" />
<div class="shadow-[inset_0_35px_35px_rgba(0,0,0,0.25)]" />`
            }
        },
        {
            "title": "shadow-inset-color-purple-500/80, shadow-inset-color-[rgb(244_67_54_/75)]",
            "description": "to change the color of an inset box shadow:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-md shadow-inset-color-gray-500/80 bg-color-white",
                        "className": "",
                        "text": "shadow-inset-color-gray-500/80",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-md shadow-inset-color-purple-500/80 bg-color-white",
                        "className": "",
                        "text": "shadow-inset-color-purple-500/80",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg shadow-inset-md shadow-inset-color-[rgb(244_67_54_/75)] bg-color-white",
                        "className": "",
                        "text": "shadow-inset-color-[rgb(244_67_54_/75)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<div class="shadow-md shadow-inset-color-gray-500/80" />
<div class="shadow-md shadow-inset-color-purple-500/80" />
<div class="shadow-md shadow-inset-color-[rgb(244_67_54_/75)]" />`
            }
        },
        {
            "title": "ring, ring-<number> ",
            "description": "utilities like ring-2 and ring-4 to apply a solid box-shadow to an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring bg-color-white",
                        "className": "",
                        "text": "ring",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-2 bg-color-white",
                        "className": "",
                        "text": "ring-2",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-4 bg-color-white",
                        "className": "",
                        "text": "ring-4",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },

                ],
                "className": "relative",
                "code": `<button class="ring ..."></button>
<button class="ring-2 ..."></button>
<button class="ring-4 ..."></button>`
            }
        },
        {
            "title": "ring-color-indigo-500, ring-color-cyan-500/50",
            "description": "utilities like ring-2 and ring-4 to apply a solid box-shadow to an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-color-indigo-500 ring-2 bg-color-white",
                        "className": "",
                        "text": "ring-color-indigo-500",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-color-cyan-500/50 ring-2 bg-color-white",
                        "className": "",
                        "text": "ring-color-cyan-500/50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-color-[#f44336] ring-2 bg-color-white",
                        "className": "",
                        "text": "ring-color-[#f44336]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },

                ],
                "className": "relative",
                "code": `<button class="ring-2 ring-color-indigo-500 ..."></button>
<button class="ring-2 ring-color-cyan-500/50 ..."></button>
<button class="ring-2 ring-color-[#f44336] ..."></button>`
            }
        },
        {
            "title": "ring-inset, ring-inset-<number> ",
            "description": "utilities like ring-inset-2 and ring-inset-4 to apply a solid box-shadow to an element:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-inset bg-color-white",
                        "className": "",
                        "text": "ring-inset",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-inset-2 bg-color-white",
                        "className": "",
                        "text": "ring-inset-2",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-inset-4 bg-color-white",
                        "className": "",
                        "text": "ring-inset-4",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },

                ],
                "className": "relative",
                "code": `<button class="ring-inset ..."></button>
<button class="ring-inset-2 ..."></button>
<button class="ring-inset-4 ..."></button>`
            }
        },
         {
            "title": "ring-inset-color-indigo-500, ring-inset-color-cyan-500/50",
            "description": "to change the color of an inset ring:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-x-10 gap-y-20 !bg-none !border-0 pt-10 mb-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-inset-color-indigo-500 ring-inset-2 bg-color-white",
                        "className": "",
                        "text": "ring-inset-color-indigo-500",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-inset-color-cyan-500/50 ring-inset-2 bg-color-white",
                        "className": "",
                        "text": "ring-inset-color-cyan-500/50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "w-24 h-10 mx-auto rounded-lg text-color-gray-700 ring-inset-color-[#f44336] ring-inset-2 bg-color-white",
                        "className": "",
                        "text": "ring-inset-color-[#f44336]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },

                ],
                "className": "relative",
                "code": `<button class="ring-2 ring-color-indigo-500 ..."></button>
<button class="ring-2 ring-color-cyan-500/50 ..."></button>
<button class="ring-2 ring-color-[#f44336] ..."></button>`
            }
        },
    ]
};

export default boxShadow;